<template>
  <div class="last-child:mb-0" :class="classes" v-html="text"></div>
</template>

<script>
import { useCustomValidator } from "../../../compostables/useValidators";

export default {
  props: {
    textAlignment: {
      type: String,
      required: false,
      default: "left",
      validator(value) {
        return useCustomValidator(["left", "center"], value);
      },
    },
    textSize: {
      type: String,
      required: false,
      validator(value) {
        return useCustomValidator(["small", "medium"], value);
      },
    },
    textStyle: {
      type: String,
      required: false,
      validator(value) {
        return useCustomValidator(["navy"], value);
      },
    },
    text: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    const classes = {
      "child:text-16 child:mb-2 last-child:mb-0": props.textSize === "small",
      "text-left": props.textAlignment === "left",
      "text-center": props.textAlignment === "center",
      "child:text-navy": props.textStyle === "navy",
      "child:text-14 child:md:text-16 child:xl:text-18":
        props.textSize === "medium",
    };

    return {
      classes,
    };
  },
};
</script>
